<script lang="ts" setup>
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------
import { form, isLoaderLoginFormActivated } from '../../refs/login.form.refs';

// -------------------------------
// 🔹 Composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { CommerceMutation } from '@/mutations/commerce.mutations';
const { handleCreateCommerceContact, handleUpdateCommerceContact } =
  CommerceMutation();

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useCommerceStore } from '@/store/commerce.store';
import { useDialogStore } from '@/store/dialog.store';

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  idToDelete,
  isUpdatedFromConatct,
  form_CommerceSlugBody,
  text,
  slug,
  textVailability,
} from '@/refs/commerce.refs';

import { useQuery } from '@tanstack/vue-query';
import { watch } from 'vue';
import { isAtcivatedHorraireCommerceWatch } from '@/refs/horraire.commerce.refs';

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const commerceStore = useCommerceStore();
const dialogStore = useDialogStore();
const { handleCreateCommerceSlug } = CommerceMutation();

const {
  data: dataGetCheckAvailabilitySlugStore,
  isLoading: isLoadingGetdataGetCheckAvailabilitySlugStore,
  isError: isErrorGetDataGetCheckAvailabilitySlugStore,
  refetch: refectGetDataGetCheckAvailabilitySlugStore,
} = useQuery({
  queryKey: ['DataGetCheckAvailabilitySlugStore'],
  queryFn: () => commerceStore.checkAvailabilitySlugStore(),
});

const {
  data: dataGeCheckSuggestionsSlugStore,
  isLoading: isLoadingGetCheckSuggestionsSlugStore,
  isError: isErrorGetDataGetCheckSuggestionsSlugStore,
  refetch: refectGetDataGetCheckSuggestionsSlugStore,
} = useQuery({
  queryKey: ['DataGetCheckSuggestionsSlugStore'],
  queryFn: () => commerceStore.checkSuggestionsSlugStore(),
});

const {
  data: dataGetCommerces,
  isLoading: isLoadingGetCommerces,
  isError: isErrorGetCommerces,
  refetch: refectGetCommerces,
} = useQuery({
  queryKey: ['GetCommerces'],
  queryFn: () => commerceStore.getCommerces(),
});

// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleClose'): void;
}>();

// -------------------------------
// 🔹 Watcher pour recharger les commerces lors du changement de page ou ouverture de dialogue
// -------------------------------
watch(text, (newValue, oldValue) => {
  refectGetDataGetCheckSuggestionsSlugStore();
  textVailability.value = 'Verifier la disponibilité du  slug';
});

// -------------------------------
// 🔹 Gestion du formulaire
// -------------------------------

const handleSubmit = async () => {
  createCommerceSlug();
};

const handleClose = (): void => {
  idToDelete.value = null;
  emit('HandleClose');
};

const checkAvailabilitySlugStore = async () => {
  slug.value = text.value;
  isLoaderLoginFormActivated.value = true;
  try {
    const res = await refectGetDataGetCheckAvailabilitySlugStore();

    if (res && res.data && res.data.data) {
      const data = res?.data?.data?.data;
      setTimeout(() => {
        isLoaderLoginFormActivated.value = false;
        textVailability.value = data?.isAvalaible
          ? 'Il est disponible'
          : "Il n'est pas disponible";
      }, 1000);
    }
  } catch (error) {
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
    }, 1000);
  }
};

const createCommerceSlug = async () => {
  isLoaderLoginFormActivated.value = true;
  try {
    const data = {
      slug: text.value,
      restaurantId: form_CommerceSlugBody.restaurantId,
      setPrimary: Boolean(form_CommerceSlugBody?.setPrimary),
    };
    const res = await handleCreateCommerceSlug(data);

    if (res) {
      setTimeout(() => {
        isLoaderLoginFormActivated.value = false;
        dialogStore.closeDialog();
        isAtcivatedHorraireCommerceWatch.value =
          !isAtcivatedHorraireCommerceWatch.value;
      }, 1000);
    }
  } catch (error) {
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
    }, 1000);

    alert('error from server' + JSON.stringify(error));
  }
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <div>
        <label for="type" class="mb-1 block font-medium text-gray-700">
          Sélectionnez si ce slug sera principal pour ce commerce<span
            class="text-decroissance text-14px leadinspanrmal"
            >*</span
          >
        </label>

        <select
          required
          v-model="form_CommerceSlugBody.setPrimary"
          id="setPrimary"
          name="setPrimary"
          class="border-border-input w-full rounded-md border border-solid px-3 py-2 focus-within:border focus-within:border-solid focus:outline-none"
        >
          <option disabled value="">Sélectionnez un type</option>
          <option value="true">Principal</option>
          <option value="false">Sécondaire</option>
        </select>
      </div>

      <div class="flex w-full flex-row items-center gap-2">
        <TextInput
          required="true"
          v-model="text"
          name="Proposez-nous un slug "
          placeholder="Proposez-nous un slug"
          type="text"
          id="Proposez-nous un slug "
          label="Proposez-nous un slug "
        />

        <div class="space-y-2" v-show="text?.length > 0">
          <label
            for="type"
            class="invisible mb-1 block font-medium text-gray-700"
          >
            Sélectionnez parmis nos suggestions
          </label>

          <select
            v-model="text"
            id="setPrimary"
            name="setPrimary"
            class="border-border-input h-(--input-height) w-full rounded-md border border-solid px-3 py-2 focus-within:border focus-within:border-solid focus:outline-none"
          >
            <option disabled value="">Sélectionnez une suggestion</option>
            <option
              v-for="item in dataGeCheckSuggestionsSlugStore?.data?.data
                ?.candidates"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
        </div>

        <div class="flex-1">
          <p class="invisible">Verifier</p>
          <div @click="checkAvailabilitySlugStore">
            <BaseButtonPrimary
              :isClicked="isLoaderLoginFormActivated"
              type="button"
              :label="textVailability"
              style_of_btn="secondary_color_of_btn "
              class="text-grand-text w-full"
            />
          </div>
        </div>
      </div>

      <div class="flex w-full flex-1 flex-col gap-2">
        <label for="commerce" class="mb-1 block font-medium text-gray-700">
          Sélectionnez le commerce<span
            class="text-decroissance text-14px leadinspanrmal"
            >*</span
          >
        </label>
        <select
          id="commerce"
          name="commerce_associé"
          v-model="form_CommerceSlugBody.restaurantId"
          required
          class="border-border-input focus:ring-primary-900 focus:border-primary-900 w-full rounded-xl border bg-white px-3 py-2 text-sm text-gray-700 placeholder-gray-400 shadow-sm transition-all outline-none hover:border-gray-400 focus:ring-2"
        >
          <option value="" disabled>Veuillez sélectionner un commerce</option>
          <option
            v-for="value in dataGetCommerces?.data"
            :value="value?.id"
            class="text-14px text-secondary-text"
          >
            {{ value.designation }}
          </option>
        </select>
      </div>
    </div>

    <div class="invisible h-[50px]" />

    <div class="fixed bottom-0 left-0 w-full bg-white py-6">
      <div class="flex flex-row items-center justify-between gap-8 px-[16px]">
        <div class="w-full">
          <BaseButtonPrimary
            :isClicked="isLoaderLoginFormActivated"
            type="submit"
            :label="isUpdatedFromConatct ? 'Modifier' : 'Enregistrer'"
            style_of_btn="primary_color_of_btn "
            class="w-full text-white"
          />
        </div>

        <div class="w-full" @click="handleClose">
          <BaseButtonPrimary
            type="button"
            :label="'Annuler'"
            style_of_btn="secondary_color_of_btn "
            class="text-grand-text w-full"
          />
        </div>
      </div>
    </div>
  </form>
</template>
